import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class RoadinforApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'roadinfor'
  }

  /**
   * 查询列表(分页)
   * @param params
   * @returns 
   */
  public getListPage(params) {
    return this.send(params, "getEntitiesPage", Methods.GET)
  }
  /**
   * 查询所有的线路信息
   * @returns 
   */
  public getAllRoadInfoList(){
    return this.send({},"getAllRoadInfoList",Methods.GET)
  }
  /**
   * 保存前端画线信息
   * @param params 
   * @returns 
   */
  public saveRoadPoint(params){
    return this.send(params,"saveRoadPoint",Methods.POST)
  }

  public getEntity(id) {
    return this.send({}, "getEntity?id="+id, Methods.GET)
  }

  public deleteLine(id) {
    return this.send({}, "deleteLine?roadId="+id, Methods.GET)
  }
  

}